import React, { Component } from 'react';
import { api } from 'api/api';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import 'assets/vendors/style';
import MainApp from 'app/index';
import RTL from 'util/RTL';
import { ToastContainer } from 'react-toastify';
import asyncComponent from 'util/asyncComponent';
import { userSignOut } from 'actions/Auth';
import defaultTheme from './themes/defaultTheme';
import AppLocale from '../lngProvider';

import SignIn from './SignIn';
import SignUp from './SignUp';
import ResetPassword from '../app/pages/ResetPassword';

import { setInitUrl } from '../actions/Auth';
import 'react-toastify/dist/ReactToastify.css';

const RestrictedRoute = ({ component: Component, authUser, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      authUser ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/signin',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

class App extends Component {
  componentDidMount() {
    const userHeaders = localStorage.getItem('user');

    if (userHeaders) {
      sessionStorage.setItem('user', userHeaders);
    }
  }

  componentDidUpdate() {
    api.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response.status === 401) {
          this.props.userSignOut();
        }
        return error;
      }
    );
  }

  UNSAFE_componentWillMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
  }

  render() {
    const {
      match,
      location,
      locale,
      authUser,
      initURL,
      isDirectionRTL,
    } = this.props;
    if (location.pathname === '/') {
      if (authUser === null) {
        return <Redirect to="/signin" />;
      }
      if (initURL === '' || initURL === '/' || initURL === '/signin') {
        return <Redirect to="/app/sample-page" />;
      }
      return <Redirect to={initURL} />;
    }

    const applyTheme = createTheme(defaultTheme);

    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <MuiThemeProvider theme={applyTheme}>
        <ToastContainer />
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <RTL>
              <div className="app-main">
                <Switch>
                  <RestrictedRoute
                    path={`${match.url}app`}
                    authUser={authUser}
                    component={MainApp}
                  />
                  <Route path="/signin" component={SignIn} />
                  <Route path="/signup" component={SignUp} />
                  <Route path="/redefinir" component={ResetPassword} />
                  <Route
                    component={asyncComponent(() =>
                      import('app/components/Error404')
                    )}
                  />
                </Switch>
              </div>
            </RTL>
          </IntlProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { sideNavColor, locale, isDirectionRTL } = settings;
  const { authUser, initURL } = auth;
  return {
    sideNavColor,
    locale,
    isDirectionRTL,
    authUser,
    initURL,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setInitUrl, userSignOut }
  )(App)
);
